<main
  fxLayout="column"
  fxLayoutAlign="center center"
  class="layout"
  [ngClass.lt-sm]="{'xs sm':true}"
  [ngClass.lt-md]="{'sm':true}"
>
  <section class="mainvisual">
    <app-mainvisual></app-mainvisual>
  </section>
  <article>
    <section fxLayout="column" fxLayoutAlign="center center">
      <div class="content">
        <app-introduction></app-introduction>
      </div>
    </section>
    <section fxLayout="column" fxLayoutAlign="center center">
      <div class="content">
        <app-diagnosis-days></app-diagnosis-days>
      </div>
    </section>
    <section fxLayout="column" fxLayoutAlign="center center">
      <div class="content">
        <app-beginners></app-beginners>
      </div>
    </section>
    <section fxLayout="column" fxLayoutAlign="center center">
      <div class="content">
        <app-covid19></app-covid19>
      </div>
    </section>
    <section fxLayout="column" fxLayoutAlign="center center">
      <div class="content">
        <app-feedback></app-feedback>
      </div>
    </section>
    <section fxLayout="column" fxLayoutAlign="center center">
      <div class="content">
        <app-relation></app-relation>
      </div>
    </section>
  </article>
</main>